import { CompaniesIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <CompaniesIndexRouteView/>,
};